<template>
  <el-drawer :visible.sync="visible" :before-close="closeFn">
    <h1 style="margin-bottom:30px;">编辑车辆</h1>

    <p slot="titl">
      {{ line.startStationName }} - {{ line.endStationName }}
      <template v-if="line && line.schedulingType === 1">
        {{ scheduling.schedulingTime | filterTime("MM-DD") }}
        {{ scheduling.startTime }}
        <span v-if="scheduling.startTime && scheduling.endTime">-</span>
        {{ scheduling.endTime }}
      </template>
    </p>
    <div style="height: auto">
      <custom-table @onRowClick="onRowClick" @listBack="listBack" ref="customTable" :customOptions="customOptions"
                    :columns="columns" class="scheduling-vehicle" :show-overflow-tooltip="false" labelWidth="140"
                    :organizationId="line.organizationId || null" addText="" layout="total, prev, pager, next"
                    maxHeight="600"
                    :loadmoreSwitch="true">
        <template slot="table-operation">
          <el-table-column label="操作" width="160" fixed="right">
            <template slot-scope="{ row }">
              <el-checkbox v-if="row.driverId" :value="checkDriver.vehicleId == row.id"
                           :disabled="checkDriverOld.vehicleId == row.id" @change="onRowClick(row)"></el-checkbox>
              <span v-else class="tips">绑定值班司机后才能选择</span>
            </template>
          </el-table-column>
        </template>

        <template slot-scope="{ item, row }">
          <template v-if="item.prop === 'vehicleSeat'">{{ row.vehicleSeat }}座</template>
          <span :style="{color:row.inspectResult == 1?'#009900' : 'red'}"
                v-else-if="item.prop === 'inspectResult'">{{ statusRow[row.inspectResult] }}</span>
          <span v-else-if="item.prop === 'followPersonnelSeat'">
            <span v-if="row.followPersonnelSeat">{{ row.followPersonnelSeat }}人</span>
            <span v-else>-</span>
          </span>
          <template v-else>{{ row[item.prop] ? row[item.prop] : "-" }}</template>
        </template>
      </custom-table>
    </div>

    <div v-if="listRows" style="text-align: center; margin: 20px">
      <el-button type="primary" @click="save" style="width:50%">确定</el-button>
    </div>
  </el-drawer>
</template>

<script>
export default {
  name: "schedulingVehicle",
  directives: {
    loadmore: {
      bind(el, binding) {
        const selectWrap = el.querySelector(".el-table__body-wrapper");
        selectWrap.addEventListener("scroll", function () {
          const sign = 1;
          const scrollDistance =
              this.scrollHeight - this.scrollTop - this.clientHeight;
          if (scrollDistance <= sign) {
            binding.value();
          }
        });
      },
    },
  },
  props: {
    line: {
      default() {
        // 线路信息
        return {};
      },
    },
    scheduling: {
      // 班次信息
      default() {
        return {};
      },
    },
    list: {
      default() {
        return [];
      },
    },
    vehicleId: {
      default() {
        return null;
      },
    },
    visible: {
      default() {
        return false;
      },
    },
  },
  data() {
    return {
      statusRow: {
        '-1': '未安检',
        '0': '安检不合格',
        '1': '正常',
        '2': '安检超期',
      },
      viewLoading: false,
      viewTitle: "",
      viewData: [],
      viewPages: {
        page: 1,
        size: 20,
      },
      // 表单
      form: {},
      Dataresult: {
        result: [],
      },
      // 校验规则
      rules: {},
      // 保存按钮loading
      loading: false,
      listRows: false,
      dialogVisible2: false,
      checkDriver: {}, // 选择结果
      checkDriverOld: {}, // 传入的原有数据
      // 配置项
      customOptions: {
        // 请求的列表url
        url: "/api/v1/manage/line/vehicle/duty",
        // 请求的参数列表
        params: {
          page: 1, // 页数
          size: 15, // 每页条数
          channel: 2,
        },
        search: [
          {
            type: "input",
            field: "vehicleNo",
            name: "车辆编号",
            value: "",
          },
          {
            type: "input",
            field: "licenseNo",
            name: "车辆号牌",
            value: "",
          },
        ],
      },
      columns: [
        {prop: "licenseNo", label: "车辆号牌"},
        {prop: "vehicleNo", label: "车辆编号"},
        {prop: "driverName", label: "值班司机"},
        {prop: "vehicleSeat", label: "座位数"},
        {prop: "followPersonnelSeat", label: "随车人数"},
        {prop: "inspectResult", label: "安检状态"}
      ],
    };
  },
  watch: {
    visible: {
      handler(val) {
        if (val) {
          this.customOptions.params.page = 1;
          this.customOptions.params.organizationId = this.line.organizationId;
          if (this.$refs.customTable) {
            this.$refs.customTable.listFn();
          }
          setTimeout(() => {
            this.checkDriver = this.list.find(item => item.id == this.vehicleId) || {}
            this.checkDriverOld = this.list.find(item => item.id == this.vehicleId) || {}
            this.list.forEach((item) => {
              if (item.id == this.vehicleId) {
                this.listRows = true;
              }
            });
          }, this.list.length > 0 ? 1 : 500);
        } else {
          this.listRows = false;
        }
      },
      immediate: true,
      deep: true,
    },
  },
  created() {
    this.customOptions.url = this.mixinUserInfo.platformType === 2 ? '/api/v1/manage/line/vehicle/duty/station' : '/api/v1/manage/line/vehicle/duty'
  },
  methods: {
    listBack(e) {
      Object.assign(this.list, e);
    },
    //模态框
    handleClose(done) {
      this.$confirm("确认关闭？")
          .then(() => {
            done();
          })
          .catch(() => {
          });
    },
    save() {
      this.$emit("update:visible", false);
      this.$emit("confirm", this.checkDriver);
      this.listRows = false;
    },

    async onRowClick(obj) {
      if (this.checkDriverOld.vehicleId == obj.id) {
        return;
      }

      if (obj.driverName == null) {
        this.$message.closeAll();
        this.$message.warning("所选车辆没有值班司机，无法添加");
        return;
      }

      this.listRows = true;

      let row = this.$utils.deepCopyFn(obj);

      delete row.lineVehicleList;
      delete row.schedulingCount;

      if (row.driverId) {
        if (row.organizationId !== this.line.organizationId && this.mixinUserInfo.platformType !== 2) {
          this.$message.warning("所选车辆与当前线路不在同一机构，无法添加");
          return;
        }
        this.checkDriver = row;
      }
    },
    closeFn(done) {
      this.$emit("update:visible", false);
      done(false);
    },
  },
};
</script>

<style lang="less">
.el-drawer__header {
  right: 6%;
}

.scheduling-vehicle {
  .icon-checked {
    color: @color-primary;
  }

  .line-text {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  #customSearch .customTable-top .grouping-field {
    display: grid;
    overflow: hidden;
    grid-template-columns: 1fr 1fr 1fr 1fr;

    .grouping-field-item {
      min-width: 200px !important;
    }
  }
}

.cont {
  display: flex;
  text-align: center;
  margin: 32px auto 0;

  .cont-left {
    display: flex;
    flex-wrap: wrap;
    width: 300px;

    .driverslist {
      text-align: center;
      font-size: 16px;
      font-weight: 600;
      color: #333333;
      margin-left: 60px;
    }

    .passe1 {
      > p {
        text-align: center;
        font-size: 16px;
        font-weight: 600;
        color: #333333;
      }

      &:nth-child(2) {
        margin-left: 60px;
        margin-right: 60px;
      }

      &:nth-child(3) {
        margin-left: 30px;
      }

      &:nth-child(4) {
        margin-left: 40px;
      }

      &:nth-child(5) {
        margin-left: 40px;
      }
    }

    .passe2 {
      > p {
        text-align: center;
        font-size: 16px;
        font-weight: 600;
        color: #333333;
      }

      &:nth-child(2) {
        margin-left: 60px;
        margin-right: 60px;
      }

      &:nth-child(3) {
        margin-left: 60px;
      }

      &:nth-child(4) {
        margin-left: 60px;
        margin-right: 60px;
      }

      &:nth-child(5) {
        margin-left: 40px;
      }

      &:nth-child(6) {
        margin-left: 30px;
      }

      &:nth-child(7) {
        margin-left: 40px;
      }
    }

    .passe3 {
      > p {
        text-align: center;
        font-size: 16px;
        font-weight: 600;
        color: #333333;
      }

      &:nth-child(2) {
        margin-left: 60px;
        margin-right: 60px;
      }

      &:nth-child(3) {
        margin-left: 30px;
      }

      &:nth-child(4) {
        margin-left: 40px;
      }

      &:nth-child(5) {
        margin: 0 40px;
      }

      &:nth-child(6) {
        margin-left: 30px;
      }

      &:nth-child(7) {
        margin-left: 40px;
      }

      &:nth-child(8) {
        margin-left: 40px;
      }
    }

    .passe4 {
      > p {
        text-align: center;
        font-size: 16px;
        font-weight: 600;
        color: #333333;
      }

      &:nth-child(2) {
        margin-left: 60px;
        margin-right: 60px;
      }

      &:nth-child(3) {
        margin-left: 60px;
      }

      &:nth-child(4) {
        margin-left: 60px;
        margin-right: 60px;
      }

      &:nth-child(5) {
        margin-left: 60px;
      }

      &:nth-child(6) {
        margin-left: 60px;
        margin-right: 60px;
      }

      &:nth-child(7) {
        margin-left: 40px;
      }

      &:nth-child(8) {
        margin-left: 30px;
      }

      &:nth-child(9) {
        margin-left: 40px;
      }
    }

    .driver {
      width: 40px;
      height: 40px;
      background: #ccc;
      background: url("../../../assets/img/zuowei2.png");
    }

    .passenger {
      width: 40px;
      height: 40px;
      background: url("../../../assets/img/zuowei1.png") 100% 100%;
    }
  }

  .cont-right {
    margin-left: 20px;

    .driver-number {
      margin-right: 10px;
      display: inline-block;
      color: #333333;
      width: 36px;
      font-size: 16px;
      font-weight: 600;
      line-height: 21px;
    }

    .input-suffix {
      font-size: 13px;
      font-weight: bold;
      line-height: 28px;
      color: #333333;
      padding: 0 6px 0 0;
    }

    > div {
      margin-bottom: 16px;
    }
  }
}

.head {
  display: flex;

  p {
    line-height: 28px;
    display: flex;
    align-items: center;
    color: #999999;
  }
}

.titl {
  border-left: 4px solid #409efc;
  color: #333333;
  width: 550px;
  height: 27px;
  font-size: 20px;
  font-weight: 600;
  line-height: 27px;
  color: #333333;
  opacity: 1;
  text-indent: 6px;
  display: flex;
  justify-content: space-between;
}

.dian {
  display: inline-block;
  width: 6px;
  height: 6px;
  background: #999999;
  border-radius: 50%;
  opacity: 1;
  margin-right: 6px;
}

// 禁用input的number箭头
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}

input[type="number"] {
  -moz-appearance: textfield;
}
</style>
